var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"iframe",staticClass:"d-block",staticStyle:{"width":"100%","height":"420px"},attrs:{"src":_vm.iframeUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }